import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'content',
  label: 'Content / Policy Section',
  description: 'Generic rich-text section for policies and descriptions.',
  supportedPages: ['privacy-policy', 'terms-of-service', 'shipping-policy', 'return-policy'],
  variants: [{ id: 'v1', label: 'V1 (Readable Layout)' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string' },
    { key: 'content', label: 'HTML Content', type: 'rich-text' },
  ],
}
